import { get, post } from "../client";
import { LIST_PAYMENT_REQUESTS, CREATE_PAYMENT_REQUEST, GET_PAYMENT_REQUEST, CANCEL_PAYMENT_REQUEST, RESEND_PAYMENT_REQUEST } from "../routes";

const PAYMENT_REQUESTS = {
  list: async ({ status = "ALL", page = 1, size = 20, search = "" } = {}) => {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    if (page) params.append("page", String(page));
    if (size) params.append("size", String(size));
    if (search) params.append("search", search);
    return await get(`${LIST_PAYMENT_REQUESTS}?${params.toString()}`);
  },
  create: async (data) => await post(CREATE_PAYMENT_REQUEST, data),
  getOne: async (id) => await get(GET_PAYMENT_REQUEST(id)),
  cancel: async (id) => await post(CANCEL_PAYMENT_REQUEST(id), {}),
  resend: async (id, channel) => await post(RESEND_PAYMENT_REQUEST(id), channel ? { channel } : {}),
};
export default PAYMENT_REQUESTS;
